import React, { Component } from "react";
import { Link } from 'react-router-dom'

import firebase from "../Firebase";
import { ReactComponent as Sunny } from '../img/weatherIcons/wi-day-sunny.svg'
import { ReactComponent as PtCloud } from '../img/weatherIcons/wi-day-cloudy.svg'
import { ReactComponent as Thunderstorms } from '../img/weatherIcons/wi-day-lightning.svg'
import { ReactComponent as ScatteredStorms } from '../img/weatherIcons/wi-day-rain-mix.svg'
import { ReactComponent as WindRain } from '../img/weatherIcons/wi-day-cloudy-windy.svg'
import { ReactComponent as WindRainHeavy } from '../img/weatherIcons/wi-day-rain-wind.svg'
import { ReactComponent as Showers } from '../img/weatherIcons/wi-showers.svg'
import { ReactComponent as Smoke } from '../img/weatherIcons/wi-smoke.svg'
import Concern from '../views/Concern'
class Detail extends Component {
constructor(props) {
super(props);
this.ref = firebase.firestore().collection("test").orderBy("startDate", "desc");
this.unsubscribe = null;
this.state = {
boards: [],
};

}
onCollectionUpdate = (querySnapshot) => {
const boards = [];
    querySnapshot.forEach((doc) => {
    const {
        activity,
        algae,
        dead,
        date,
        habitat,
        observation,
        river,
        section,
        startDate,
        temperature,
        waterTemperature,
        weather,
        fieldNotes,
        lat,
        lon,
    } = doc.data();
boards.push({
    key: doc.id,
    doc, // DocumentSnapshot
    activity,
    algae,
    dead,
    date,
    habitat,
    observation,
    river,
    section,
    startDate,
    temperature,
    waterTemperature,
    weather,
    fieldNotes,
    lat,
    lon,
    });

    });
    this.setState({
    boards,
    });
    };

    componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
    }

render() {
return (

<div className="body">
<Link to="/map/view">View Area Map</Link>
<div className="alert-ok center"><h1>Reported Spots</h1></div>
       
       
{this.state.boards.map((board) => (<>
    <div class="card">
            <div className="card-heading">
            <div className="col-3a">
    <div><div className="card-tl">
            {board.weather ==="Sunny" ? <Sunny className="weather-icon-sunny" />  : null}
            {board.weather ==="Party cloudy" ? <PtCloud className="weather-icon-cloudy" />  : null}
            {board.weather ==="High Clouds with breezes" ? <WindRain className="weather-icon-cloudy" />  : null}
            {board.weather ==="Thunderstorms" ? <Thunderstorms className="weather-icon-cloudy" />  : null}
            {board.weather ==="Scattered showers" ? <ScatteredStorms className="weather-icon-cloudy" />  : null}
            {board.weather ==="Wind and rain" ? <WindRainHeavy className="weather-icon-cloudy" />  : null}
            {board.weather ==="Steady rain" ? <Showers className="weather-icon-cloudy" />  : null}
            {board.weather ==="Smoke" ? <Smoke className="weather-icon-cloudy" />  : null}	
        </div></div>
    <div><h2>  
                
                {!board.otherRiver ? <>{board.river}</> : null}
                    {board.otherRiver && board.river ==="Other" ? <>{board.otherRiver}</> : null}
                </h2>
                <h3>{board.section ? <>{board.section}</>: null }</h3></div>
                <div ><p>Reported on: {board.date}</p></div>
</div>
                <div>
                
            </div>
        <div>
            <div>
          </div>
        </div>
        

            </div>

<div className="col-2-content">
    <div>
        <div><p><b>Air Temperature: </b>{board.temperature}<sup>&deg;</sup></p></div>
        <div><p><b>Habitat Type Sampled:</b> {board.habitat}</p></div>
        <div><p><b>Streambed Observation: </b>{board.algae} </p></div>
    
        <div><p><b>Volunteers Activity: </b>{board.activity} </p></div>
       <div><p><b>Notes: </b>{board.fieldNotes}</p></div> 
        {board.lat ? <div>
            <p><b>Latitude: </b>{board.lat}</p><p><b>Longitude:</b> {board.lon}</p>
        </div> : null}
        
        
       
        
    </div>
    <div>
       
    <div className="temperature-display">
                {board.waterTemperature >= "70" ? 
                <>
                <div className="temperature-display-hot temp-box">{board.waterTemperature}<sup>&deg;</sup></div>
                    <div className="caption">
                        <p>Temperatures are above optimal for animal health. 
                        Extra monitoring is required in this area.
                        </p>
                    </div>
                </>
                 : null}
                {board.waterTemperature >= "65" && board.waterTemperature <="69" ? 
                <><div className="temperature-display-warm temp-box">{board.waterTemperature}<sup>&deg;</sup></div>
                <div className="caption">Temperatures are becoming dangerous! Extra monitoring is required in this area.</div>
                </>
                 : null}
                {board.waterTemperature >= "53" && board.waterTemperature <="64" ? 
                <>
                 <div className="temperature-display-good temp-box">{board.waterTemperature}<sup>&deg;</sup>
                </div>
                <div className="caption">Temperature is within normal range for aquatic life to thrive.</div>
                </>
                 : null}
                {board.waterTemperature >= "42" && board.waterTemperature <="52" ? 
                <>
                <div className="temperature-display-perfect temp-box">{board.waterTemperature}<sup>&deg;</sup></div>
                    <div className="caption">Temperature is ideal.</div> </>
                : null}
                
            </div>
    </div>
</div>


<div className="col-2-content">

    <div className="button-row-2a">
            
        </div>
    </div>
</div>
</>
))}
</div>

);
}
}

export default Detail;